export default {
  Title: 'Nghiệp vụ',
  Budget: 'Dự toán ngân sách',
  Salary: 'Tiền lương',
  FundManagement: 'Quản lý quỹ',
  InventoryManagement: 'Quản lý kho',
  ReceiveBudget: 'Nhận dự toán',
  PlanActivityBySource: 'Lập dự toán chi NDKT theo nguồn',
  PlanReceiptByBudget: 'Lập dự toán thu theo MLNS',
  PlanExpenseByBudget: 'Lập dự toán chi theo MLNS',
  UseCouncilPlan: 'Theo dõi dự toán thu/ chi theo MLNS/ NDKT do HĐND giao',
  EnterBudgetSpendMLNS: 'Nhập dự toán chi theo MLNS đến',
  EnterBudgetIncomeMLNS: 'Nhập dự toán thu theo MLNS đến',
  CommuneBudgetCollection: 'Thu ngân sách xã',
  BudgetChapter: 'Chương',
  BudgetKindItem: 'Loại khoản',
  BudgetGroupItem: 'Nhóm mục chi',
  BudgetItem: 'Mục',
  BudgetSubItem: 'Tiểu mục',
  BudgetSubItemDetail: 'Tiết',
  BudgetSource: 'Nguồn',
  RateFixed: 'Tỉ lệ điều tiết cố định',
  RateChanged: 'Tỉ lệ điều thiết thay đổi',
  ChangePlanActivityBySourceTitle: 'Lập dự toán chi NDKT theo nguồn',
  ChangePlanActivityBySource: 'Nếu thay đổi tùy chọn, số liệu liên quan đến dự toán chi theo NDKT đã lập sẽ bị xóa. Bạn có muốn thay đổi không?',
  BudgetAccounting: 'Kế toán ngân sách',
  IsDetailByBudgetProvidence: 'Theo dõi mã dự phòng',
  OtherBusiness: 'Nghiệp vụ khác',
  AllowOverCashPayment: 'Cho phép chi quá số tồn',
  AllowOverOutwardStock: 'Cho phép xuất quá số lượng tồn',
  IsVuThu: 'Theo dõi mẫu đặc thù Vũ Thư'

};
